import ModelDelete from "@/pages/modals/_delete";
import { useDeleteTenantMutation } from "@/services/tenant.service";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export default function Delete() {
    const {t} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [deleteTenant, {isSuccess}] = useDeleteTenantMutation()

    const onAccept = () => {
      deleteTenant(location.state?.id || "")
    }

    useEffect(() => {
      if (isSuccess) {
        navigate(location, {state: {reload: true}})
      }
    }, [isSuccess])
    
    return <ModelDelete title={t("modal.delete_tenant")} content={t("modal.delete_tenant_content")} onAccept={onAccept} />
}
